var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-flex align-center" },
    [
      _c(_setup.TimeInput, {
        staticClass: "w-100",
        attrs: {
          value: _setup.selectedTime.from,
          label: _setup.t("От", _setup.options),
        },
        on: { input: _setup.handleInputFrom, blur: _setup.handleBlur },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "text-h5 text--secondary mx-4" }, [
        _vm._v("\n    —\n  "),
      ]),
      _vm._v(" "),
      _c(_setup.TimeInput, {
        ref: "timeInputToRef",
        staticClass: "w-100",
        attrs: {
          value: _setup.selectedTime.to,
          label: _setup.t("До", _setup.options),
        },
        on: { input: _setup.handleInputTo, blur: _setup.handleBlur },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }